// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".story-impact{align-items:center;display:flex;font-size:max(var(--font-size-2xs),min(calc(1px + 1.6vw),var(--font-size-xs)));line-height:var(--lineHeight-md);line-height:var(--font-size-md)}.story-impact__icon{color:var(--color-secondary);font-size:2em;margin-right:.25em}.story-impact__label{opacity:.8}.story-impact--card .story-impact__icon{font-size:1.75em}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
